module.exports = __webpack_public_path__ + "static/workforce.e40ab8e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workforce.svg
// module id = 505
// module chunks = 35783957827783